import { createApp } from "vue";
import ElementPlus from "element-plus";
import router from "./router";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "./assets/css/dufault.css";
import './assets/css/element-variables.scss'
import App from "./App.vue";

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css' // 引入雪主题样式

const app = createApp(App).use(router);

app.use(ElementPlus, {
  locale: zhCn,
});
app.component('QuillEditor', QuillEditor) // 全局注册
// 全局使用cookies
import VueCookies from 'vue-cookies'
app.use(VueCookies)

// 自定义警告处理器：过滤特定警告
app.config.warnHandler = (msg, instance, trace) => {
  // 其他警告正常打印（保留默认行为）
  console.warn(`[Vue warn]: ${msg}\n${trace}`);
}

// main.js 或入口文件
const ignoreErrors = [
  "ResizeObserver loop completed with undelivered notifications",
  "ResizeObserver loop limit exceeded"
];
  
window.addEventListener('error', e => {
  let errorMsg = e.message;
  ignoreErrors.forEach(m => {
    if (errorMsg.startsWith(m)) {
      console.error(errorMsg);
      if (e.error) {
        console.error(e.error.stack);
      }
  
      // 隐藏开发环境 overlay 报错界面
      const resizeObserverErrDiv = document.getElementById(
        'webpack-dev-server-client-overlay-div'
      );
      const resizeObserverErr = document.getElementById(
        'webpack-dev-server-client-overlay'
      );
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute('style', 'display: none');
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute('style', 'display: none');
      }
    }
  });
});

app.mount("#app");
